export function mapMemberToOption({ id, userName, profilePicture, roleName, email, salutation }) {
  return {
    value: id,
    label: userName,
    picture: profilePicture,
    roleName,
    email,
    salutation
  };
}

export function mapRoleName(roleName) {
  const roleNames = {
    "HR-ADMIN": "HR-Admin",
    RECRUITER: "Recruiter",
    "DEPARTMENT-SCOUT": "Department-Scout",
    "HR-MANAGER": "HR-Manager",
    "MARKETING-MANAGER": "Marketing-Manager",
    ANALYST: "Analyst"
  };

  return roleNames[roleName];
}
